import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

export default function ModalCustomerBureau(props) {
  const customerB = props.model;

  return (
    <Modal
      title="Cliente mesa"
      model={customerB}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      entity="base/customer-bureau"
    >
      <FormControl fullWidth size="small" margin="normal">
        <InputLabel>Canal</InputLabel>
        <Select
          defaultValue={!!customerB ? customerB.base_canal_id : ''}
          inputProps={{
            name: 'base_canal_id'
          }}
        >
          {props.canals.map((item, i) => {
            return (
              <MenuItem value={item.id} key={i}>
                {item.description}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </Modal>
  );
}
